import React from "react";
import BaseInput from "./BaseInput";

interface PasswordInputProps {
  password: string;
  setPassword: (value: string) => void;
  useFloatingLabel?: boolean;
  label?: string;
}

export default function PasswordInput({
  password,
  setPassword,
  useFloatingLabel = true,
  label = "Password"
}: PasswordInputProps) {
  return (
    <BaseInput
      value={password}
      onChange={setPassword}
      label={label}
      type="password"
      useFloatingLabel={useFloatingLabel}
    />
  );
} 